import { Braces } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { TAG_DISPONIBILI } from '@email/mergeTags.ts';

interface MergeTagPickerProps {
  onScelto: (frammento: string) => void;
}

/**
 * I segnaposto che si possono infilare nel testo.
 *
 * Ognuno viene inserito con un valore di riserva gia' scritto ({{nome|...}}):
 * e' quello che evita il "Ciao ," a chi non ha il nome compilato, ed e' molto
 * piu' facile che qualcuno lo tolga di sua volonta' che se lo ricordi da solo.
 */
export function MergeTagPicker({ onScelto }: MergeTagPickerProps) {
  const riserve: Record<string, string> = {
    nome: 'cliente',
    nome_completo: 'cliente',
    azienda: 'la vostra azienda',
    citta: '',
    provincia: '',
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border border-gray-200 bg-white text-xs text-neutral-600 hover:bg-gray-50"
          title="Inserisci un dato del destinatario"
        >
          <Braces className="w-3.5 h-3.5" />
          Dati del destinatario
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        {TAG_DISPONIBILI.map((tag) => {
          const riserva = riserve[tag.nome];
          const frammento = riserva ? `{{${tag.nome}|${riserva}}}` : `{{${tag.nome}}}`;
          return (
            <DropdownMenuItem key={tag.nome} onClick={() => onScelto(frammento)}>
              <div className="min-w-0">
                <div className="text-sm">{tag.descrizione}</div>
                <div className="text-[11px] text-neutral-400 truncate">es. {tag.esempio}</div>
              </div>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
